<template>
  <div class="lottery" :class="{'lottery-margin': creationMode}">
    <div class="com-title">
      <span class="main-title">抽奖设置</span>
      <!-- <span  class="tips left">(九宫格)</span> -->
      <div class="tips bottom"><van-icon name="info-o" size="12" />
        抽奖组件说明最多设置8个奖品。大转盘将依据奖品数量进行变化。所有奖品中奖概率之和最大是100%
      </div>
    </div>
    <template v-for="(item,index) in form">
      <div class="com-content" :key="index" :class="{'com-box-margin': creationMode}">
        <div class="prize-name">
          <span>{{index + 1 | prizeName}}</span>
          <div class="button-box">
            <div class="cancel"  @click="deleteLottery(item,index)">删除</div>
            <div class="replace" @click="editPrize(item,index)">编辑</div>
          </div>
        </div>
        <van-field
          v-model="item.prizeName"
          label="奖品类型" 
          label-align="left" 
          input-align="right" 
          readonly  
          class="signup-type top" 
        />
        <template v-if="item.awardType == 'redPack'">
          <van-field 
            label="单个红包金额(元)" 
            label-width="9em"
            label-align="left" 
            input-align="right" 
            class="signup-type" 
            placeholder="请输入红包金额"
            readonly
            :maxlength="4"
            type="number"
            v-model="item.singleAmount"
          >
          </van-field>
          <van-field 
            label="红包个数(个)" 
            label-align="left" 
            input-align="right" 
            class="signup-type" 
            type="digit"
            :maxlength="4"
            readonly
            placeholder="请输入红包个数"
            v-model="item.awardNumber"
          >
          </van-field>
          <van-field 
            label="中奖概率(%)" 
            label-align="left" 
            input-align="right" 
            class="signup-type" 
            type="number"
            readonly
            placeholder="请输入中奖概率"
            v-model="item.winProbability"
          >
          </van-field>
        </template>
        <template v-else>
          <van-field 
            label="奖品名称" 
            label-align="left" 
            input-align="right" 
            class="signup-type" 
            :maxlength="10"
            readonly
            placeholder="请输入奖品名称"
            v-model="item.awardName"
          />
          <van-field 
            label="奖品份数(份)" 
            label-align="left" 
            input-align="right" 
            class="signup-type"
            type="digit"
            :maxlength="4"
            readonly
            placeholder="请输入奖品份数"
            v-model="item.awardNumber"
          >
          </van-field>
          <van-field 
            label="中奖概率(%)" 
            label-align="left" 
            input-align="right" 
            class="signup-type"
            readonly
            placeholder="请输入中奖概率"
            v-model="item.winProbability"
          >
          </van-field>
        </template>
        <div class="img" v-if="item.awardType == 'award'">
          <div class="img-title">奖品图片</div>
          <van-uploader 
            :deletable="false"
            class="uploader" 
            :fileList="item.bakImg" 
            :max-count="1" 
            preview-size="97" 
            result-type="file"
            readonly
          />
        </div>
      </div>
    </template>
    <div class="add-range-btn" @click="addPrize" v-if="(form && form.length )< 8">
      <van-icon name="plus" />
      添加奖品
    </div>
    <add-lottery-pop 
      :isAddLotteryPop.sync="isAddLotteryPop" 
      :prize="prize"
      :value="value"
      :withdrawConfig="withdrawConfig"
      :createdTime="createdTime"
      :isDit="isDit"
      @addPrizeSucess="addPrizeSucess"
    />
  </div>
</template>

<script>
import addLotteryPop from './add-lottery-pop'
import { randomNumber } from '@/utils/utils'
import _ from 'loadsh'

export default {
  components: { 
    addLotteryPop
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value:  {
      type: Object,
      default() {
        return {}
      }
    },
    isDit: {
      type: Boolean,
      default: false
    },
    createdTime: [String,Number]
  },
  computed: {
    form: {
      get() {
        return this.value.prizeList
      },
      set(newVal) {
        this.$emit('change', newVal)
      }
    },
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    },
    isEditPirze() {
      return this.$route.query.from == 'manager' ? true : false
    }
  },
  data() {
    return {
      isAddLotteryPop: false,
      prize: {},
      isPrizeType: false,
      currentPrizeIndex: 0,
      isEdit: false,
      withdrawConfig: {}
    }
  },
  created() {
    this.queryPublicityData()
  },
  methods: {
    addPrize() {
      if (this.form.length > 8) {
        this.$toast('最多只能添加8个奖品')
        return
      }
      const number = randomNumber(1,1000000);
      this.prize = {
        moduleGroupCode: `award-${number}`, 
        awardType: 'award', // 奖品类型 
        singleAmount: '',  // 单个红包金额
        awardNumber: '',  // 奖品个数
        winProbability: '', // 中奖概率
        awardName: '', // 奖品名称
        prizeName: '奖品',
        isNewAdd: true,
        bakImg: []
      }
      this.isAddLotteryPop = true
    },
    addPrizeSucess(prize) {
      if (this.isEdit) {
        this.form[this.currentPrizeIndex] = prize
      }else {
        this.form.push(prize)
      }
      this.isEdit = false
    },
    editPrize(prize,index) {
      this.isEdit = true
      this.currentPrizeIndex = index
      this.prize = _.cloneDeep(prize) 
      this.isAddLotteryPop = true
    },
    deleteLottery(prize,index) {
      this.$dialog.confirm({
        title: '提示',
        message: '请问是否删除奖品，删除后将无法恢复！',
      })
        .then(() => {
           if (this.isEditPirze) {
            this.deleteCall(prize,index)
          }else {
            this.form.splice(index, 1)
          }
        })
      return
    },
    deleteCall(item,index) {
      let params = {
        activityId: this.value.activityId,
        moduleId: this.value.moduleId,
        moduleGroupCode: item.moduleGroupCode
      }
      this.$api.luckDraw.delete(params).then(res => {
        this.form.splice(index, 1)
        this.$toast('删除成功')
      })
    },
    successCallback(title) {
      this.$toast(title)
      setTimeout(()=>{
        this.bus.$emit('handleSuccess')
      },2000)
    },
    queryPublicityData(){
      this.$api.h5.queryPublicityData('wx_withdraw_config')
        .then(res => {
          if (res.success) {
            const {openRechargeAndWithdraw, time} = res.data
            this.withdrawConfig = {openRechargeAndWithdraw,time}
          }
          
        })
    }
  },
  filters: {
    prizeName(value) {
      let map = {
        1: '奖品(一)',
        2: '奖品(二)',
        3: '奖品(三)',
        4: '奖品(四)',
        5: '奖品(五)',
        6: '奖品(六)',
        7: '奖品(七)',
        8: '奖品(八)',
      }
      return map[value]
    }
  }
}
</script>

<style lang="stylus" scoped>
  .lottery {
    .com-title {
      padding: 15px
      .main-title {
        font-size: 14px;
        font-weight: bold;
        color: #303133;
      }
      .left {
        margin-left: 10px;
      }
      .tips {
        font-size: 12px;
        color: #999;
      }
      .bottom {
        margin-top: 4px;
      }
    }
    .com-content {
      padding 4px
      background-color: #fff
      border-radius: 8px
      .prize-name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #606266;
        font-weight: 600;
        height: 30px;
        margin: 0 15px;
        .replace {
          color: #ff6b31;
        }
        .button-box {
          display: flex;
          .cancel {
            font-weight: 10;
            margin-right: 20px;
          }
        }
      }
      .signup-type {
        span {
          margin-left: 10px;
        }
      }
      .img {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        margin-left: 15px;
      }
      .uploader {
         >>> .van-uploader__preview {
          border-radius: 8px;
          overflow: hidden;
            .van-uploader__preview-delete {
              width: 20px;
              height: 20px;
              border-bottom-left-radius: 18px;
                .van-uploader__preview-delete-icon {
                  font-size 20px
                }
            }
         }
      }
    }
    .com-box-margin {
      margin 10px 15px
    }
    .add-range-btn {
      margin 15px
      padding 10px 0
      text-align: center
      color $mainTextColor
      font-size 14px
      font-weight 600
      border 1px solid $mainTextColor
      border-radius 8px
    }
  }
  .lottery-margin {
    margin: 15px 0;
  }
</style>